module.exports = __webpack_public_path__ + "static/moonlitNightClassicalSnippet2Arranged-8e84bd068b284ca073d6b3cc8c625529.mp3";